"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgValidation(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a8 8 0 110 16 8 8 0 010-16zm2.592 4.07L12 6.66 9.408 4.07a.237.237 0 00-.334 0L8.069 5.073a.236.236 0 000 .335L10.661 8l-2.592 2.592a.236.236 0 000 .334l1.005 1.005a.236.236 0 00.334 0L12 9.339l2.592 2.592a.237.237 0 00.335 0l1.004-1.005a.237.237 0 000-.334L13.339 8l2.592-2.592a.237.237 0 000-.334l-1.004-1.005a.237.237 0 00-.335 0z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Validation')(SvgValidation);
//# sourceMappingURL=Validation.js.map